import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vue-carousel" }
const _hoisted_2 = { class: "vue-carousel-box" }

import { onMounted, ref, computed } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import { LabData } from '@/types/LabData';
import ArrowLeft from '@/components/icons/CarouselLeft.vue';
import RecentCard from '@/components/Carousel/RecentCard.vue';
import CarouselPagination from '@/components/Carousel/CarouselPagination.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CarouselRecentLabCards',
  props: {
    list: {}
  },
  setup(__props: any) {

const props = __props;

const currentSlide = ref(0);
const carouselRef = ref();
const paginationRef = ref();
const breakpoints = ref();
const hasHiddenCard = computed(() => paginationRef.value?.hasHiddenCard ?? false);

onMounted(() => {
  breakpoints.value = {
    // 300 and up
    300: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 1.25 : 1,
      snapAlign: 'start',
    },
    575: {
      itemsToShow: 2,
      snapAlign: 'start',
    },
    800: {
      itemsToShow: 3,
      snapAlign: 'start',
    },
    1080: {
      itemsToShow: 4,
      snapAlign: 'start',
    },
    1280: {
      itemsToShow: 5,
      snapAlign: 'start',
    },
    1600: {
      itemsToShow: 7,
      snapAlign: 'start',
    },
  };
});

const slideEnd = () => {
  paginationRef.value.updVisibleCards();
};

const findIndex = () => {
  const visibleCards = paginationRef.value?.visibleCards || [];
  const index = visibleCards.findIndex((x: boolean) => x);
  return index < 0 ? 0 : index;
};

const navigate = (direction: number) => {
  const currentIndex = findIndex();
  const newIndex = currentIndex + direction;
  carouselRef.value.slideTo(newIndex);
};

const prev = () => {
  navigate(-1);
};
const next = () => {
  navigate(1);
};

const isRightArrowDisabled = computed(() => {
  const visibleCount = paginationRef.value?.visibleCards.filter((i) => i).length;
  return currentSlide.value === props.list.length - visibleCount;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (hasHiddenCard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["vue-carousel__arrow vue-carousel__prev", { disabled: currentSlide.value === 0 }]),
            onClick: prev
          }, [
            _createVNode(ArrowLeft)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_unref(Carousel), {
        ref_key: "carouselRef",
        ref: carouselRef,
        modelValue: currentSlide.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
        breakpoints: breakpoints.value,
        onSlideEnd: slideEnd
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (card, index) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              key: index,
              class: "slideEl"
            }, {
              default: _withCtx(() => [
                _createVNode(RecentCard, {
                  card: card as LabData,
                  disableStorageUpdate: true,
                  class: "carousel__slide"
                }, null, 8, ["card"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "breakpoints"]),
      (hasHiddenCard.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["vue-carousel__arrow vue-carousel__next", { disabled: isRightArrowDisabled.value }]),
            onClick: next
          }, [
            _createVNode(ArrowLeft)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(CarouselPagination, {
      ref_key: "paginationRef",
      ref: paginationRef,
      carouselRef: carouselRef.value
    }, null, 8, ["carouselRef"])
  ]))
}
}

})